const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const USER_KEY = 'user';

export const loadAccessToken = () =>
  localStorage.getItem(ACCESS_TOKEN_KEY) || localStorage.getItem('token');

export const saveAccessToken = (token: string | null) => {
  if (token) {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
    localStorage.removeItem('token');
  } else {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem('token');
  }
};

export const loadRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const saveRefreshToken = (token: string | null) => {
  if (token) {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }
};

export const loadUser = <T = any>(): T | null => {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as T;
  } catch (error) {
    console.error('저장된 사용자 정보를 읽을 수 없습니다.', error);
    localStorage.removeItem(USER_KEY);
    return null;
  }
};

export const saveUser = (user: any | null) => {
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } else {
    localStorage.removeItem(USER_KEY);
  }
};













